import { render, staticRenderFns } from "./home-page-product-slider.vue?vue&type=template&id=37b98a22&scoped=true&"
import script from "./home-page-product-slider.vue?vue&type=script&lang=js&"
export * from "./home-page-product-slider.vue?vue&type=script&lang=js&"
import style0 from "./home-page-product-slider.vue?vue&type=style&index=0&id=37b98a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../MultiSiteClient/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b98a22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VCard,VCol,VIcon,VImg,VRow,VSlideGroup,VSlideItem})


/* vuetify-loader */
import installDirectives from "!../../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
